import { ENV, getConfig } from "@/constants/envConfig";
import { createFromIconfontCN } from "@ant-design/icons";

const env = process.env.NEXT_PUBLIC_DEPLOY_ENV_LOCAL || ENV;
const config = getConfig();
const iconfontVersion = config.NEXT_ICONFONT_VERSION || "prod";

// public的所有文件都会上传至OSS的： https://cdn.huaban.com/_next/public/${env} 下, 看 cdn.js 文件逻辑
const iconfontUrl =
  env === "local"
    ? "/_assets/iconfont/iconfont.js"
    : `https://cdn.huaban.com/_next/public/${iconfontVersion}/_assets/iconfont/iconfont.js`;

console.info("iconfontUrl", iconfontUrl);

export default createFromIconfontCN({
  scriptUrl: iconfontUrl,
});
